import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-21" }, null, -1)
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_16 = { class: "ss-margin-campos" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_19 = { class: "ss-margin-campos" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-15" }
const _hoisted_21 = { class: "ss-margin-campos" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-1 ss-alinhar-centro" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_26 = { class: "ant-row" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_produto_dados_principais = _resolveComponent("produto-dados-principais")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_marcador = _resolveComponent("selecionar-marcador")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_display_tela_personalizada = _resolveComponent("display-tela-personalizada")!
  const _component_card = _resolveComponent("card")!
  const _component_produto_codigos = _resolveComponent("produto-codigos")!
  const _component_produto_adicionar_variacao = _resolveComponent("produto-adicionar-variacao")!
  const _component_produto_editar_variacao = _resolveComponent("produto-editar-variacao")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_produto_custos = _resolveComponent("produto-custos")!
  const _component_produto_precos = _resolveComponent("produto-precos")!
  const _component_produto_estoque = _resolveComponent("produto-estoque")!
  const _component_produto_unidades = _resolveComponent("produto-unidades")!
  const _component_produto_itens_kit = _resolveComponent("produto-itens-kit")!
  const _component_produto_peso_medidas = _resolveComponent("produto-peso-medidas")!
  const _component_produto_fornecedores = _resolveComponent("produto-fornecedores")!
  const _component_produto_imagens = _resolveComponent("produto-imagens")!
  const _component_produto_caracteristicas = _resolveComponent("produto-caracteristicas")!
  const _component_produto_dados_especificos = _resolveComponent("produto-dados-especificos")!
  const _component_produto_semelhantes = _resolveComponent("produto-semelhantes")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: "97%",
      "wrap-class-name": "full-modal ss-modal-cadastros",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event))
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Cadastro de Produto "),
        _createVNode(_component_a_switch, {
          checked: _ctx.state.produto.ativo,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.produto.ativo) = $event)),
          style: {"float":"right"},
          "checked-children": "Ativo",
          "un-checked-children": "Inativo"
        }, null, 8, ["checked"])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir)
              || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.UtilitarioGeral.valorValido(_ctx.modalBase.textoBotaoSalvarNovo))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "ant-btn ant-btn-lg ant-btn-secondary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando,
          paragraph: { rows: 15 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                (_ctx.state.exibirCamposPersonalizados)
                  ? (_openBlock(), _createBlock(_component_display_tela_personalizada, {
                      key: 0,
                      codigoRegistro: _ctx.state.produto.codigo,
                      personalizacao: _ctx.state.personalizacaoTela
                    }, {
                      AbaPrincipal: _withCtx(() => [
                        _createVNode(_component_produto_dados_principais, {
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          produto: _ctx.state.produto,
                          "onUpdate:produto": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.produto) = $event)),
                          categoriasSelecionadas: _ctx.state.categoriasSelecionadas,
                          "onUpdate:categoriasSelecionadas": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.categoriasSelecionadas) = $event))
                        }, null, 8, ["empresas", "produto", "categoriasSelecionadas"]),
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_a_form_item, {
                              label: "Data de cadastro",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data, {
                                  dataSelecionada: _ctx.state.produto.dataCadastro,
                                  "onUpdate:dataSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.produto.dataCadastro) = $event)),
                                  horaMinutoSegundo: true,
                                  disabled: true,
                                  placeholder: ""
                                }, null, 8, ["dataSelecionada"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_a_form_item, {
                              label: "Data última alteração",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data, {
                                  dataSelecionada: _ctx.state.produto.dataAlteracao,
                                  "onUpdate:dataSelecionada": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.produto.dataAlteracao) = $event)),
                                  horaMinutoSegundo: true,
                                  disabled: true,
                                  placeholder: ""
                                }, null, 8, ["dataSelecionada"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.telaBase.apresentarEmpresas ? 'ant-col ant-col-xs-24 ant-col-xl-9' : 'ant-col ant-col-xs-24 ant-col-xl-18')
                          }, [
                            _createVNode(_component_a_form_item, {
                              label: "Marcadores",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_marcador, {
                                  marcadoresSelecionados: _ctx.state.marcadoresSelecionados,
                                  "onUpdate:marcadoresSelecionados": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.marcadoresSelecionados) = $event))
                                }, null, 8, ["marcadoresSelecionados"])
                              ]),
                              _: 1
                            })
                          ], 2),
                          _withDirectives(_createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_a_form_item, {
                              label: "Empresas",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_empresa, {
                                  varias: true,
                                  empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                                  codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                                  "onUpdate:codigosSelecionados": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
                                }, null, 8, ["empresasEspecificas", "codigosSelecionados"])
                              ]),
                              _: 1
                            })
                          ], 512), [
                            [_vShow, _ctx.telaBase.apresentarEmpresas]
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["codigoRegistro", "personalizacao"]))
                  : (_openBlock(), _createBlock(_component_card, {
                      key: 1,
                      titulo: "DADOS PRINCIPAIS"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_produto_dados_principais, {
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          produto: _ctx.state.produto,
                          "onUpdate:produto": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.produto) = $event)),
                          categoriasSelecionadas: _ctx.state.categoriasSelecionadas,
                          "onUpdate:categoriasSelecionadas": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.categoriasSelecionadas) = $event)),
                          onAlterarVariacao: _ctx.comportamentoVariacoes
                        }, null, 8, ["empresas", "produto", "categoriasSelecionadas", "onAlterarVariacao"]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.telaBase.apresentarEmpresas ? 'ant-col ant-col-xs-24 ant-col-xl-12' : 'ant-col ant-col-xs-24 ant-col-xl-24')
                          }, [
                            _createVNode(_component_a_form_item, {
                              label: "Marcadores",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_marcador, {
                                  marcadoresSelecionados: _ctx.state.marcadoresSelecionados,
                                  "onUpdate:marcadoresSelecionados": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.marcadoresSelecionados) = $event))
                                }, null, 8, ["marcadoresSelecionados"])
                              ]),
                              _: 1
                            })
                          ], 2),
                          _withDirectives(_createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_a_form_item, {
                              label: "Empresas",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_empresa, {
                                  varias: true,
                                  empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                                  codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                                  "onUpdate:codigosSelecionados": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
                                }, null, 8, ["empresasEspecificas", "codigosSelecionados"])
                              ]),
                              _: 1
                            })
                          ], 512), [
                            [_vShow, _ctx.telaBase.apresentarEmpresas]
                          ])
                        ])
                      ]),
                      _: 1
                    })),
                (!_ctx.state.produto.possuiVariacao && _ctx.state.produto.definicoes.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_produto_codigos, {
                        codigoInterno: _ctx.state.produto.definicoes[0].codigoInterno,
                        "onUpdate:codigoInterno": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.produto.definicoes[0].codigoInterno) = $event)),
                        codigos: _ctx.state.produto.definicoes[0].codigos,
                        "onUpdate:codigos": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.produto.definicoes[0].codigos) = $event))
                      }, null, 8, ["codigoInterno", "codigos"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.modalBase.computedVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tabs, null, {
                            default: _withCtx(() => [
                              (_ctx.state.produto.possuiVariacao)
                                ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                    key: "0",
                                    tab: "VARIAÇÕES",
                                    style: {"padding-top":"5px"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.state.caracteristicasCadastradas.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, [
                                              _hoisted_12,
                                              _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "ant-btn ant-btn-secondary",
                                                  style: {"width":"100%"},
                                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.adicionarNovaVariacao()))
                                                }, " Adicionar Variação ")
                                              ])
                                            ]),
                                            _createVNode(_component_produto_adicionar_variacao, {
                                              ref: "refAdicionarVariacao",
                                              definicoesProdutos: _ctx.state.produto.definicoes,
                                              "onUpdate:definicoesProdutos": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.produto.definicoes) = $event)),
                                              caracteristicasCadastradas: _ctx.state.caracteristicasCadastradas
                                            }, null, 8, ["definicoesProdutos", "caracteristicasCadastradas"]),
                                            _createVNode(_component_produto_editar_variacao, {
                                              ref: "refEditarVariacao",
                                              descricaoProduto: _ctx.state.produto.descricao,
                                              codigoUnidadePrincipal: _ctx.state.produto.codigoUnidade,
                                              fatorUnidadePrincipal: _ctx.state.produto.fatorUnidadePrincipal,
                                              "onUpdate:fatorUnidadePrincipal": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.produto.fatorUnidadePrincipal) = $event)),
                                              definicoesProdutos: _ctx.state.produto.definicoes,
                                              "onUpdate:definicoesProdutos": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.produto.definicoes) = $event)),
                                              caracteristicasCadastradas: _ctx.state.caracteristicasCadastradas,
                                              empresas: _ctx.telaBase.empresasSelecionadas
                                            }, null, 8, ["descricaoProduto", "codigoUnidadePrincipal", "fatorUnidadePrincipal", "definicoesProdutos", "caracteristicasCadastradas", "empresas"]),
                                            (_ctx.state.produto.definicoes.length <= 0)
                                              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                                  key: 0,
                                                  mensagem: "Nenhuma variação do produto foi adicionada ainda"
                                                }))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.produto.definicoes, (definicaoProduto, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      class: "ant-row ss-grade-personalizada-linha",
                                                      key: index
                                                    }, [
                                                      _createElementVNode("div", _hoisted_15, [
                                                        _createElementVNode("div", _hoisted_16, [
                                                          _createElementVNode("button", {
                                                            type: "button",
                                                            class: "ant-btn ant-btn-primary ant-btn-block",
                                                            onClick: ($event: any) => (_ctx.editarVariacao(definicaoProduto, index))
                                                          }, " Editar variação ", 8, _hoisted_17)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_18, [
                                                        _createElementVNode("div", _hoisted_19, " Código interno: " + _toDisplayString((definicaoProduto.codigoInterno ? definicaoProduto.codigoInterno : '---')), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_20, [
                                                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.servicoProduto.montaDescricaoVariacaoProduto(definicaoProduto.caracteristicasVariacao,
                                _ctx.state.caracteristicasCadastradas)), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_22, [
                                                        _createElementVNode("button", {
                                                          class: "ant-btn ant-btn-secondary",
                                                          onClick: ($event: any) => (_ctx.removerVariacao(index))
                                                        }, [
                                                          _createVNode(_component_icone, { nome: "excluir" })
                                                        ], 8, _hoisted_23)
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ]))
                                          ]))
                                        : (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                            key: 1,
                                            mensagem: "Nenhuma característica localizada ou cadastrada"
                                          }))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.state.produto.possuiVariacao)
                                ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                    key: "1",
                                    tab: "CUSTOS E PREÇOS",
                                    style: {"padding-top":"5px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_produto_custos, {
                                        carregando: _ctx.state.carregandoCustos,
                                        tiposCustos: _ctx.state.tiposCustos,
                                        custos: _ctx.state.produto.definicoes[0].custos,
                                        "onUpdate:custos": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.produto.definicoes[0].custos) = $event))
                                      }, null, 8, ["carregando", "tiposCustos", "custos"]),
                                      _createVNode(_component_produto_precos, {
                                        empresa: _ctx.props.operacao.empresaSelecionada,
                                        carregando: _ctx.state.carregandoPrecos,
                                        tiposPrecos: _ctx.state.tiposPrecos,
                                        custos: _ctx.state.produto.definicoes[0].custos,
                                        tabelasPrecos: _ctx.state.tabelasPrecos,
                                        precos: _ctx.state.produto.definicoes[0].precos,
                                        "onUpdate:precos": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.produto.definicoes[0].precos) = $event))
                                      }, null, 8, ["empresa", "carregando", "tiposPrecos", "custos", "tabelasPrecos", "precos"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.state.produto.possuiVariacao)
                                ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                    key: "2",
                                    tab: "ESTOQUE"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_produto_estoque, {
                                        empresas: _ctx.telaBase.empresasSelecionadas,
                                        tipoRastreabilidade: _ctx.state.produto.definicoes[0].tipoRastreabilidade,
                                        "onUpdate:tipoRastreabilidade": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.produto.definicoes[0].tipoRastreabilidade) = $event)),
                                        tipoLancamentoRastreabilidade: _ctx.state.produto.definicoes[0].tipoLancamentoRastreabilidade,
                                        "onUpdate:tipoLancamentoRastreabilidade": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.produto.definicoes[0].tipoLancamentoRastreabilidade) = $event)),
                                        pontoPedido: _ctx.state.produto.definicoes[0].pontoPedido,
                                        "onUpdate:pontoPedido": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.produto.definicoes[0].pontoPedido) = $event)),
                                        tempoReposicao: _ctx.state.produto.definicoes[0].tempoReposicao,
                                        "onUpdate:tempoReposicao": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.produto.definicoes[0].tempoReposicao) = $event)),
                                        bloquearNovasCompras: _ctx.state.produto.definicoes[0].bloquearNovasCompras,
                                        "onUpdate:bloquearNovasCompras": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.produto.definicoes[0].bloquearNovasCompras) = $event)),
                                        validadeDias: _ctx.state.produto.definicoes[0].validadeDias,
                                        "onUpdate:validadeDias": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.produto.definicoes[0].validadeDias) = $event)),
                                        codigoEstoquePrincipal: _ctx.state.produto.definicoes[0].codigoEstoquePrincipal,
                                        "onUpdate:codigoEstoquePrincipal": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.produto.definicoes[0].codigoEstoquePrincipal) = $event))
                                      }, null, 8, ["empresas", "tipoRastreabilidade", "tipoLancamentoRastreabilidade", "pontoPedido", "tempoReposicao", "bloquearNovasCompras", "validadeDias", "codigoEstoquePrincipal"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.state.produto.possuiVariacao)
                                ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                    key: "3",
                                    tab: "UNIDADES",
                                    style: {"padding-top":"5px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_produto_unidades, {
                                        empresas: _ctx.telaBase.empresasSelecionadas,
                                        codigoUnidadePrincipal: _ctx.state.produto.codigoUnidade,
                                        fatorUnidadePrincipal: _ctx.state.produto.fatorUnidadePrincipal,
                                        "onUpdate:fatorUnidadePrincipal": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.produto.fatorUnidadePrincipal) = $event)),
                                        unidades: _ctx.state.produto.definicoes[0].unidades,
                                        "onUpdate:unidades": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.produto.definicoes[0].unidades) = $event)),
                                        codigos: _ctx.state.produto.definicoes[0].codigos,
                                        "onUpdate:codigos": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.produto.definicoes[0].codigos) = $event))
                                      }, null, 8, ["empresas", "codigoUnidadePrincipal", "fatorUnidadePrincipal", "unidades", "codigos"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.state.produto.produtoKit)
                                ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                    key: "4",
                                    tab: "KIT"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_produto_itens_kit, {
                                        codigoProdutoDefinicao: _ctx.state.produto.definicoes[0].codigo,
                                        itens: _ctx.state.produto.itensKit,
                                        "onUpdate:itens": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.produto.itensKit) = $event)),
                                        empresas: _ctx.telaBase.empresasSelecionadas
                                      }, null, 8, ["codigoProdutoDefinicao", "itens", "empresas"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.state.produto.possuiVariacao)
                                ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                    key: "5",
                                    tab: "PESO E MEDIDAS"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_produto_peso_medidas, {
                                        pesoEmbalagem: _ctx.state.produto.definicoes[0].pesoEmbalagem,
                                        "onUpdate:pesoEmbalagem": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.produto.definicoes[0].pesoEmbalagem) = $event)),
                                        pesoBruto: _ctx.state.produto.definicoes[0].pesoBruto,
                                        "onUpdate:pesoBruto": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.produto.definicoes[0].pesoBruto) = $event)),
                                        pesoLiquido: _ctx.state.produto.definicoes[0].pesoLiquido,
                                        "onUpdate:pesoLiquido": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.produto.definicoes[0].pesoLiquido) = $event)),
                                        comprimento: _ctx.state.produto.definicoes[0].comprimento,
                                        "onUpdate:comprimento": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.produto.definicoes[0].comprimento) = $event)),
                                        altura: _ctx.state.produto.definicoes[0].altura,
                                        "onUpdate:altura": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.produto.definicoes[0].altura) = $event)),
                                        largura: _ctx.state.produto.definicoes[0].largura,
                                        "onUpdate:largura": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.produto.definicoes[0].largura) = $event)),
                                        calculoParaVolume: _ctx.state.produto.definicoes[0].calculoParaVolume,
                                        "onUpdate:calculoParaVolume": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.produto.definicoes[0].calculoParaVolume) = $event))
                                      }, null, 8, ["pesoEmbalagem", "pesoBruto", "pesoLiquido", "comprimento", "altura", "largura", "calculoParaVolume"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.state.produto.possuiVariacao)
                                ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                    key: "6",
                                    tab: "FORNECEDORES"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_produto_fornecedores, {
                                        empresas: _ctx.telaBase.empresasSelecionadas,
                                        fornecedores: _ctx.state.produto.definicoes[0].fornecedores,
                                        "onUpdate:fornecedores": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.produto.definicoes[0].fornecedores) = $event))
                                      }, null, 8, ["empresas", "fornecedores"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.state.produto.possuiVariacao)
                                ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                    key: "7",
                                    tab: "IMAGENS",
                                    style: {"padding-top":"5px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_produto_imagens, {
                                        empresas: _ctx.telaBase.empresasSelecionadas,
                                        imagens: _ctx.state.produto.definicoes[0].imagens,
                                        "onUpdate:imagens": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.state.produto.definicoes[0].imagens) = $event))
                                      }, null, 8, ["empresas", "imagens"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_a_tab_pane, {
                                key: "8",
                                tab: "CARACTERÍSTICAS"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_produto_caracteristicas, {
                                    empresas: _ctx.telaBase.empresasSelecionadas,
                                    caracteristicas: _ctx.state.produto.caracteristicas,
                                    "onUpdate:caracteristicas": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.produto.caracteristicas) = $event))
                                  }, null, 8, ["empresas", "caracteristicas"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_tab_pane, {
                                key: "9",
                                tab: "DADOS ESPECÍFICOS",
                                style: {"padding-top":"5px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_produto_dados_especificos, {
                                    empresas: _ctx.telaBase.empresasSelecionadas,
                                    medicamento: _ctx.state.produto.medicamento,
                                    "onUpdate:medicamento": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.state.produto.medicamento) = $event)),
                                    produtoMedicamento: _ctx.state.produto.medicamentoDetalhe,
                                    "onUpdate:produtoMedicamento": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.state.produto.medicamentoDetalhe) = $event)),
                                    combustivel: _ctx.state.produto.combustivel,
                                    "onUpdate:combustivel": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.state.produto.combustivel) = $event)),
                                    produtoCombustivel: _ctx.state.produto.combustivelDetalhe,
                                    "onUpdate:produtoCombustivel": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.state.produto.combustivelDetalhe) = $event)),
                                    aditivo: _ctx.state.produto.aditivo,
                                    "onUpdate:aditivo": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.state.produto.aditivo) = $event)),
                                    aditivoDetalhe: _ctx.state.produto.aditivoDetalhe,
                                    "onUpdate:aditivoDetalhe": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.state.produto.aditivoDetalhe) = $event)),
                                    componenteNutricional: _ctx.state.produto.componenteNutricional,
                                    "onUpdate:componenteNutricional": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.state.produto.componenteNutricional) = $event)),
                                    componentesNutricionais: _ctx.state.produto.componentesNutricionais,
                                    "onUpdate:componentesNutricionais": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.state.produto.componentesNutricionais) = $event)),
                                    registroMapa: _ctx.state.produto.registroMapa,
                                    "onUpdate:registroMapa": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.state.produto.registroMapa) = $event)),
                                    registroMapaDetalhe: _ctx.state.produto.registroMapaDetalhe,
                                    "onUpdate:registroMapaDetalhe": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.state.produto.registroMapaDetalhe) = $event))
                                  }, null, 8, ["empresas", "medicamento", "produtoMedicamento", "combustivel", "produtoCombustivel", "aditivo", "aditivoDetalhe", "componenteNutricional", "componentesNutricionais", "registroMapa", "registroMapaDetalhe"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_tab_pane, {
                                key: "10",
                                tab: "SEMELHANTES"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_produto_semelhantes, {
                                    empresas: _ctx.telaBase.empresasSelecionadas,
                                    semelhantes: _ctx.state.produto.produtosSemelhantes,
                                    "onUpdate:semelhantes": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.state.produto.produtosSemelhantes) = $event))
                                  }, null, 8, ["empresas", "semelhantes"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_tab_pane, {
                                key: "11",
                                tab: "DESCRIÇÃO COMPLETA"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Mostrar na NF-e",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_switch, {
                                            checked: _ctx.state.produto.mostrarDescricaoNfe,
                                            "onUpdate:checked": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.state.produto.mostrarDescricaoNfe) = $event)),
                                            "checked-children": "Sim",
                                            "un-checked-children": "Não"
                                          }, null, 8, ["checked"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                      _createVNode(_component_editor_html, {
                                        value: _ctx.state.produto.descricaoCompleta,
                                        "onUpdate:value": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.state.produto.descricaoCompleta) = $event))
                                      }, null, 8, ["value"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}